module.exports = __webpack_public_path__ + "static/media/center_image.5b3954f4.svg";